// src/app/reports/reportDefinitions.ts

export type ReportSectionDefinition = {
  title?: string;
  columns?: {
    key: string;
    label: string;
    align?: "left" | "right" | "center";
  }[];
};

export const reportSectionDefinitions: Record<string, ReportSectionDefinition> = {
  budgetByCostCenter: {
    title: "Budget by cost centre",
    columns: [
      { key: "costCenterCode", label: "Code" },
      { key: "costCenterName", label: "Cost centre" },
      { key: "budgetFormatted", label: "Budget", align: "right" },
    ],
  },

  budgetByAccountGroup: {
    title: "Budget by account group",
    columns: [
      { key: "groupCode", label: "Groupe" },
      { key: "budgetFormatted", label: "Budget", align: "right" },
    ],
  },

  budgetByAccount: {
    title: "Budget par compte",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Description" },
      { key: "budgetFormatted", label: "Budget", align: "right" },
    ],
  },

  adoptedVsRevised: {
    title: "Adopted vs revised budget",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Description" },
      { key: "adoptedAmount", label: "Adopted", align: "right" },
      { key: "revisedAmount", label: "Revised", align: "right" },
      { key: "deltaFormatted", label: "Variance", align: "right" },
    ],
  },

  executionByCostCenter: {
    title: "Execution by cost centre",
    columns: [
      { key: "costCenterCode", label: "Code" },
      { key: "costCenterName", label: "Cost centre" },
      { key: "budgetAmount", label: "Budget", align: "right" },
      { key: "actualAmount", label: "Actual", align: "right" },
      { key: "varianceAmount", label: "Variance", align: "right" },
      { key: "executionPct", label: "Execution %", align: "right" },
    ],
  },

  executionByAccount: {
    title: "Execution by account",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Description" },
      { key: "budgetAmount", label: "Budget", align: "right" },
      { key: "actualAmount", label: "Actual", align: "right" },
      { key: "varianceAmount", label: "Variance", align: "right" },
      { key: "executionPct", label: "Execution %", align: "right" },
    ],
  },

  criticalVariance: {
    title: "Variances critiques",
    columns: [
      { key: "accountCode", label: "Compte" },
      { key: "accountName", label: "Description" },
      { key: "costCenterCode", label: "Centre" },
      { key: "varianceAmount", label: "Variance", align: "right" },
      { key: "variancePct", label: "Variance %", align: "right" },
    ],
  },

  activityDetail: {
    title: "Activity details",
    columns: [
      { key: "activityCode", label: "Code" },
      { key: "activityName", label: "Activity" },
      { key: "costCenterCode", label: "Centre" },
      { key: "plannedFormatted", label: "Planned", align: "right" },
      { key: "actualFormatted", label: "Actual", align: "right" },
      { key: "progressPct", label: "Progression %", align: "right" },
    ],
  },

  kpiDetail: {
    title: "KPI details",
    columns: [
      { key: "kpiCode", label: "Code" },
      { key: "kpiName", label: "KPI" },
      { key: "costCenterCode", label: "Centre" },
      { key: "targetValue", label: "Cible", align: "right" },
      { key: "actualValue", label: "Actual", align: "right" },
      { key: "actualPct", label: "Score %", align: "right" },
    ],
  },
};